<template>
    <div class="channel-dis" v-if="isInit">
        <div class="label-item">
            <p class="label-text">{{ field.desc }}</p>
            <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content">
                    - name: <strong>{{ field.name }}</strong
                    ><br />
                    - 多项条件组合，后面项优先级高于前面项；<br />
                    - 不选渠道和渠道组代表默认项；
                </div>
                <i class="label-icon el-icon-info"></i>
            </el-tooltip>
        </div>
        <div class="no-item" v-if="!field.def_val || !field.def_val.length">
            暂无内容，点击 + 号新增
        </div>
        <el-form
            ref="form"
            :model="field"
            :rules="fieldRules"
            label-width="120px"
        >
            <div class="infinite-list-wrapper" ref="dynamicScroller">
                <div class="infinite-list">
                    <DynamicScroller
                        :items="field.def_val"
                        :min-item-size="300"
                        class="scroller"
                        :page-mode="field.def_val.length < 5 ? false : true"
                        :key-field="'scroller_id'"
                    >
                        <template v-slot="{ item, index, active }">
                            <DynamicScrollerItem
                                :item="item"
                                :active="active"
                                :size-dependencies="[item.content]"
                                :data-index="index"
                            >
                                <div class="input-group">
                                    <span class="group-label"
                                        >{{ `第${index + 1}项 `
                                        }}<strong>{{
                                            ` 共${field.def_val.length}项`
                                        }}</strong></span
                                    >
                                    <el-form-item label="渠道" prop="channels">
                                        <el-select
                                            class="channel-select"
                                            v-model="item.channels"
                                            placeholder="请选择渠道（多项条件组合，后面项优先级高于前面项；不选渠道和渠道组代表默认项；）"
                                            multiple
                                            remote
                                            reserve-keyword
                                            filterable
                                            allow-create
                                            default-first-option
                                            :remote-method="
                                                remoteChannelsHandler
                                            "
                                        >
                                            <el-option
                                                v-for="item2 in channels.slice(
                                                    0,
                                                    100
                                                )"
                                                :key="item2.name"
                                                :label="item2.realname"
                                                :value="item2.name"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="渠道组"
                                        prop="channel_groups"
                                    >
                                        <el-select
                                            class="channel-select"
                                            v-model="item.channel_groups"
                                            placeholder="请选择渠道组（多项条件组合，后面项优先级高于前面项；不选渠道和渠道组代表默认项；）"
                                            multiple
                                            filterable
                                            reserve-keyword
                                        >
                                            <el-option
                                                v-for="item2 in channel_groups"
                                                :key="item2.name"
                                                :label="
                                                    channelGroupLabel(item2)
                                                "
                                                :value="item2.name"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="数据元件"
                                        prop="editor_base"
                                    >
                                        <el-select
                                            class="item-input"
                                            size="medium"
                                            v-model="item.editor_base"
                                            placeholder="请选择数据元件"
                                            @change="
                                                editorBaseChangeHandler(
                                                    $event,
                                                    item,
                                                    index
                                                )
                                            "
                                        >
                                            <el-option
                                                v-for="item2 in editorBases"
                                                :key="item2.type"
                                                :label="item2.label"
                                                :value="item2.type"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        v-if="item.editor_base"
                                        label="受控内容"
                                        prop="content"
                                    >
                                        <!-- <el-input class="field-input" v-model="item.content" :placeholder="`请填写受控内容`"></el-input> -->
                                        <div
                                            class="field-edit-block"
                                            :class="[
                                                item.editor_base ==
                                                'wangeditor_richtext'
                                                    ? 'is-wangeditor'
                                                    : ''
                                            ]"
                                        >
                                            <component
                                                :is="
                                                    item.editor_base.replace(
                                                        /\_/g,
                                                        '-'
                                                    )
                                                "
                                                :key="`field_${index}`"
                                                :ref="`field_${index}`"
                                                :field="{
                                                    def_val: item.content
                                                }"
                                                @val-change="
                                                    valChangeHandler(
                                                        index,
                                                        $event
                                                    )
                                                "
                                                :autoInit="true"
                                            >
                                            </component>
                                        </div>
                                    </el-form-item>
                                    <el-button
                                        class="remove-btn"
                                        @click="remove(index)"
                                        icon="el-icon-delete"
                                        title="删除该项"
                                    ></el-button>
                                    <div
                                        v-if="
                                            index === field.def_val.length - 1
                                        "
                                        class="no-more"
                                    >
                                        没有更多数据，到底了
                                    </div>
                                </div>
                            </DynamicScrollerItem>
                        </template>
                    </DynamicScroller>
                </div>
            </div>
            <el-form-item>
                <el-button class="add-btn" @click="add">+</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from "moment";
import { loadScript } from "../../service/requestApi.js";
import { postErrMsg } from "@/utils/helper.js";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

export default {
    name: "channel-dis",
    props: ["field", "autoInit"],
    data() {
        return {
            fieldRules: {
                channels: {
                    required: false,
                    message: "请选择渠道",
                    trigger: "change"
                },
                channel_groups: {
                    required: false,
                    message: "请选择渠道组",
                    trigger: "change"
                },
                editor_base: {
                    required: false,
                    message: "请选择数据元件",
                    trigger: "change"
                }
            },
            selectChannel: [],
            channelSearchStr: "",
            remoteChannelsTimer: null,
            isInit: this.autoInit,
            page: 1
        };
    },
    components: {
        DynamicScroller,
        DynamicScrollerItem
    },
    watch: {},
    methods: {
        channelGroupLabel(item) {
            let { group_name, reg, type, tags_id, polymer_regs } = item,
                tips = "";
            switch (type) {
                case "tag":
                    for (let i of tags_id) {
                        tips += i.map(v => v.name).join(">") + " ";
                    }
                    break;
                case "polymer":
                    tips = polymer_regs.map(v => v.reg).join(" ");
                    break;
                default:
                    tips = reg;
                    break;
            }
            if (tips.length > 20) {
                tips = tips.slice(0, 15) + "...";
            }
            return `${group_name}(${tips})`;
        },
        valChangeHandler(index, e) {
            // 适配基本类型数据的变更
            let tmpObj = _.cloneDeep(this.field.def_val[index]);
            this.$set(tmpObj, "content", e);
            this.$set(this.field.def_val, index, tmpObj);
            this.$nextTick(() => {
                if (this.$refs[`field_${index}`]) {
                    this.$refs[`field_${index}`].$forceUpdate();
                }
            });
            
        },
        editorBaseChangeHandler(e, item, index) {
            const editorBasesIndex = _.findLastIndex(
                this.editorBases,
                v => v.type === e
            );
            if (editorBasesIndex !== -1) {
                this.$set(
                    item,
                    "content",
                    this.editorBases[editorBasesIndex].def_val
                );
                this.$set(this.field.def_val, index, item);
                this.$nextTick(() => {
                    this.$refs[`field_${index}`].$forceUpdate();
                });
            }
        },
        remoteChannelsHandler(str) {},
        remove(index) {
            this.field.def_val.splice(index, 1);
        },
        add() {
            if (!this.field.def_val) {
                this.$set(this.field, "def_val", []);
            }

            let newId = this.field.def_val.length;

            this.field.def_val.push({
                channels: [],
                channel_groups: [],
                editor_base: "text_box",
                content: "",
                scroller_id: newId
            });

            //增加新项滚动到底部
            this.$nextTick(() => {
                this.$refs["dynamicScroller"].scrollTop = this.$refs[
                    "dynamicScroller"
                ].scrollHeight;
            });
        },
        fieldBeReady() {
            // 确认组件是否就绪，外部调用
            return this.$refs["form"];
        },
        getResField() {
            let isValidate = true;
            _.map(this.field.def_val, (item, index) => {
                const fieldEle = this.$refs[`field_${index}`];
                let tmpVal = null;
                if (fieldEle && typeof fieldEle.getResField === "function") {
                    tmpVal = fieldEle.getResField();
                    if (tmpVal) {
                        // 更新field
                        this.$set(item, "content", tmpVal.def_val);
                        this.$set(this.field.def_val, index, item);
                    } else {
                        isValidate = false;
                    }
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        },
        initData() {
            this.isInit = true;
            this.$store.dispatch("getChannelGroups", {
                per_page: 1000
            });
            if (!this.field.def_val) {
                this.$set(this.field, "def_val", []);
            }
            if (!this.field.def_val.length) {
                this.field.def_val.push({
                    channels: [],
                    channel_groups: [],
                    editor_base: "text_box",
                    content: "",
                    scroller_id: 0
                });
            }
            _.map(this.field.def_val, async (item, index) => {
                if (!item.editor_base) {
                    this.$set(item, "editor_base", "text_box");
                }
                //设置独立id，用于虚拟列表
                this.$set(item, "scroller_id", index);
            });
        }
    },
    computed: {
        channels() {
            let tmpArr = [];
            tmpArr = _.filter(this.$store.state.dataChannels.list, item => {
                return (
                    item.realname
                        .toLocaleLowerCase()
                        .search(this.channelSearchStr.toLocaleLowerCase()) !==
                    -1
                );
            });
            return tmpArr;
        },
        channel_groups() {
            return this.$store.state.dataChannelGroups.list;
        },
        editorBases() {
            return _.filter(this.$store.state.editorBases, v => {
                return (
                    v.type !== "channel_dis" &&
                    v.type !== "image_list" &&
                    v.type !== "img_item"
                );
            });
        }
    },
    mounted() {}
};
</script>
<style lang="less">
@import (reference) "../../styles/public.less";
.channel-dis {
    .label-item();
    .no-item {
        text-align: center;
        line-height: 40px;
        color: #666;
    }
    .form-label {
        font-weight: 700;
        line-height: 24px;
        font-size: 14px;
    }
    .input-group {
        border-bottom: solid 1px #ddd;
        position: relative;
    }
    .group-label {
        font-size: 13px;
        color: #606266;
        line-height: 30px;
    }
    .channel-select {
        width: 100%;
    }
    .field-edit-block {
        background-color: #fff;
        padding: 10px;
    }
    .is-wangeditor {
        min-height: 352px;
    }
    .no-more {
        text-align: center;
    }
    .remove-btn {
        position: absolute;
        top: 30px;
        left: 0px;
        padding: 10px;
    }
    .add-btn {
        margin-top: 10px;
    }
    .infinite-list-wrapper {
        max-height: 600px;
        overflow: auto;
    }
    .scroller {
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/channelDis.vue